<input
  #inputEl
  id="email-typeahead"
  type="text"
  [focusFirst]="false"
  class="form-control"
  [ngbTypeahead]="ngbTypeahead"
  (input)="onInput(inputEl)"
  (selectItem)="onSelect($event)"
  (focus)="focus$.next(inputEl.value)"
  [placeholder]="placeholder | translate"
  [resultFormatter]="resultFormatter"
  [inputFormatter]="inputFormatter"
/>
